import React from 'react';
import { Table, TableHead, TableBody, TableCell } from '@material-ui/core';

const ApproveTable = (props) => {
  return (
    <Table>
      <TableHead>
        <TableCell>Name</TableCell>
        <TableCell>Description</TableCell>
        <TableCell>Frequency</TableCell>
        <TableCell>Quantity</TableCell>
        <TableCell>Price</TableCell>
      </TableHead>
      <TableBody>{props.children}</TableBody>
    </Table>
  );
};

export default ApproveTable;
